import {useEffect, useMemo, useState} from 'react';
import {theme} from "./RewardSystem";
import RewardBubble from "./RewardBubble";
import RenderIf from "../../../../core/components/render-if";

export default function SectionBubbles({ section, sectionIndex, onRewardClick }) {

    const [isUnlocked, setIsUnlocked] = useState(true)
    useEffect(() => {
        section?.awards.map((award) => {
            if (award?.canGet === true){
                setIsUnlocked(true)
            }
        })
    }, [section]);

    const getRewardStatus = (reward) => {
        if (reward?.beforeTakenStatus === 'taken') return 'earned';
        if (reward?.canGet === true) return 'available';
        if (isUnlocked) return 'locked';
        return 'locked';
    };

    const bubblePositions = useMemo(() => {
        const count = section.awards.length;
        if (count === 0) return [];
        if (count === 4) {
            return [
                { x: 60, y: 15 },
                { x: -20, y: 80 },
                { x: 140, y: 75 },
                { x: 60, y: 150 },
            ];
        }
        return section.awards.map((_, i) => {
            const angle = (i / count) * Math.PI * 2 - Math.PI / 2;
            const radius = 90;
            return {
                x: 110 + Math.cos(angle) * radius - 50,
                y: 100 + Math.sin(angle) * radius - 50,
            };
        });
    }, [section.awards.length]);

    const sectionColors = [
        { bg: 'linear-gradient(135deg, #1a5c2a, #0d3318)', border: '#22c55e', glow: '#22c55e33' },
        { bg: 'linear-gradient(135deg, #1a3a6c, #0d1f3a)', border: '#3b82f6', glow: '#3b82f633' },
        { bg: 'linear-gradient(135deg, #6c1a1a, #3a0d0d)', border: '#ef4444', glow: '#ef444433' },
        { bg: 'linear-gradient(135deg, #6c5a1a, #3a2e0d)', border: '#eab308', glow: '#eab30833' },
        { bg: `linear-gradient(135deg, ${theme.primary}, ${theme.deep})`, border: theme.accent, glow: `${theme.accent}44` },
    ];

    const colorSet = sectionColors[sectionIndex] || sectionColors[0];

    return (
        <div className="flex flex-col items-center">
            <div
                className="relative rounded-3xl p-4 pt-6"
                style={{
                    background: isUnlocked ? colorSet.bg : 'linear-gradient(135deg, #1a1a2e, #0f0f1a)',
                    border: `2px solid ${isUnlocked ? colorSet.border : '#333'}`,
                    boxShadow: isUnlocked ? `0 0 30px ${colorSet.glow}` : 'none',
                    minWidth: 260,
                    minHeight: 260,
                    transition: 'all 0.5s ease',
                    opacity: isUnlocked ? 1 : 0.4,
                }}
            >
                <RenderIf cond={!!section?.prefix?.title}>
                <div
                    className="absolute -top-4 left-1/2  z-50 -translate-x-1/2 px-4 py-1 rounded-full text-white font-bold flex items-center gap-1.5"
                    style={{
                        background: isUnlocked
                            ? `linear-gradient(90deg, ${colorSet.border}, ${theme.primary})`
                            : 'linear-gradient(90deg, #444, #333)',
                        boxShadow: isUnlocked ? `0 2px 12px ${colorSet.glow}` : 'none',
                        fontSize: 13,
                        whiteSpace: 'nowrap',
                    }}
                >
                    <span style={{ fontSize: 16 }}>{section.icon}</span>
                    <span>{section?.prefix?.title}</span>
                </div>
                </RenderIf>

                {/*{isComplete && (*/}
                {/*    <div*/}
                {/*        className="absolute top-3 right-3 rounded-full flex items-center justify-center"*/}
                {/*        style={{*/}
                {/*            width: 22,*/}
                {/*            height: 22,*/}
                {/*            background: 'linear-gradient(135deg, #22c55e, #16a34a)',*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">*/}
                {/*            <polyline points="20 6 9 17 4 12" />*/}
                {/*        </svg>*/}
                {/*    </div>*/}
                {/*)}*/}

                <div className="flex flex-wrap items-center justify-center gap-4" style={{  width: 250, margin: '0 auto' }}>
                    {section.awards.map((reward, i) => {
                        const pos = bubblePositions[i];
                        return (
                            <div
                                key={reward.id + '-' + i + '-' + 'rewardBubble'}
                                className="flex flex-wrap"
                                style={{
                                    left: pos.x,
                                    top: pos.y,
                                    transition: 'all 0.4s ease',
                                }}
                            >
                                <RewardBubble
                                    reward={reward}
                                    status={getRewardStatus(reward)}
                                    onClick={onRewardClick}
                                />
                            </div>
                        );
                    })}
                </div>

                {!isUnlocked && (
                    <div className="absolute inset-0 flex items-center justify-center rounded-3xl backdrop-blur-[2px]">
                        <div
                            className="flex flex-col items-center gap-2 px-4 py-3 rounded-2xl"
                            style={{ background: '#00000088' }}
                        >
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                            </svg>
                            <span className="text-gray-400 text-xs font-bold">
                {section.requiredPoints} امتیاز لازم
              </span>
                        </div>
                    </div>
                )}
            </div>


        </div>
    );
}